import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoCotaDistribUnidade(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaocotadistribunidade/FIND_VISUACOTADISTRIBUNIDADE':
      case '@operacaocotadistribunidade/UPDATE_VISUACOTADISTRIBUNIDADE':
      case '@operacaocotadistribunidade/DELETE_VISUACOTADISTRIBUNIDADE':
      case '@operacaocotadistribunidade/STORE_VISUACOTADISTRIBUNIDADE':
      case '@operacaocotadistribunidade/VISUACOTADISTRIBUNIDADE_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaocotadistribunidade/SUCCESS_REMOVE':
      case '@operacaocotadistribunidade/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaocotadistribunidade/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaocotadistribunidade;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaocotadistribunidade/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaocotadistribunidade;
        break;
      }

      case '@operacaocotadistribunidade/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
